import React from 'react'
import { Link } from 'gatsby'
import {  formatDate } from '../../../../common/utils'
import { Row, Col } from '../../../../common/lib'
import classes from './ArticleCard.module.scss'
import ItemImage from '../../../../common/components/SeeAlso/ItemImage'
import replaceText from '../../../../common/utils/replaceText'

const ArticleCard = ({
  node: article,
  index,
  firstArticle = false,
  authorPage,
  tokens
}) => {
  const articleDate = formatDate(
    authorPage ? article?.meta?.publishedAt : article?.meta?.updatedAt,
    'article',
  )
  if (index === 0 && firstArticle) {
    return (
      <Link
        className={`${classes.articleLink} ${classes.standout}`}
        to={`/${article.slug}`}
        key={article.title + index}
      >
        <div className={classes.articleDate}>{articleDate}</div>
        <h2 className={classes.articleTitle}>{replaceText(tokens, article?.title)}</h2>
        <p className={classes.articleBody}>
          {replaceText(tokens, article?.metaDescription)}
        </p>
        <ItemImage
          image={article?.insetImage}
          title={article?.title}
          loading="eager"
        />
      </Link>
    )
  }
  if ((index > 0 && !firstArticle) || authorPage) {
    return (
      <Link
        className={classes.articleLink}
        to={`/${article.slug}`}
        key={article?.id}
      >
        <Row>
          <Col md={6} xs={12}>
            <ItemImage
              image={article?.insetImage}
              title={article?.title}
              loading="eager"
              tokens={tokens}
            />
          </Col>
          <Col md={6} xs={12}>
            <div className={classes.articleDate}>{articleDate}</div>
            <h5 className={classes.articleTitle}>
              {replaceText(tokens, article?.title)}
            </h5>
            <div className={classes.articleBody}>
              {article?.metaDescription &&
                replaceText(tokens, article?.metaDescription)}
            </div>
          </Col>
        </Row>
      </Link>
    )
  }
  return null
}

export default ArticleCard
